import { List } from 'immutable';
import React from 'react';

interface ExpandableTableRowContextProps {
  currentlyOpenInViewer: string;
  openRows: List<string>;
  onRowToggle: (rfiId: string) => void;
  onRowClick: (rfiId: string, rfiNumber: number) => void;
}

const ExpandableTableRowContext =
  React.createContext<ExpandableTableRowContextProps>({
    currentlyOpenInViewer: '',
    openRows: List<string>(),
    onRowToggle: () => {},
    onRowClick: () => {},
  });

export default ExpandableTableRowContext;
